/** Reasons a customer can pick when cancelling their subscription from the app (replaces the Stripe portal's built in list). */
export var SubscriptionCancelReason;
(function (SubscriptionCancelReason) {
    SubscriptionCancelReason["PreferNotToSay"] = "prefer_not_to_say";
    SubscriptionCancelReason["TooExpensive"] = "too_expensive";
    SubscriptionCancelReason["MissingFeatures"] = "missing_features";
    SubscriptionCancelReason["TooComplex"] = "too_complex";
    SubscriptionCancelReason["SwitchedService"] = "switched_service";
    SubscriptionCancelReason["NotUsingEnough"] = "not_using_enough";
    SubscriptionCancelReason["CustomersPayOnTime"] = "customers_pay_on_time";
    SubscriptionCancelReason["ClosingBusiness"] = "closing_business";
    SubscriptionCancelReason["PoorSupport"] = "poor_support";
    SubscriptionCancelReason["DidNotWork"] = "did_not_work";
    SubscriptionCancelReason["Other"] = "other";
})(SubscriptionCancelReason || (SubscriptionCancelReason = {}));
export const subscriptionCancelReasonLabels = {
    [SubscriptionCancelReason.PreferNotToSay]: `I prefer not to say`,
    [SubscriptionCancelReason.TooExpensive]: `It's too expensive`,
    [SubscriptionCancelReason.MissingFeatures]: `It's missing a feature I need`,
    [SubscriptionCancelReason.TooComplex]: `It was too hard to set up or use`,
    [SubscriptionCancelReason.SwitchedService]: `I'm switching to another tool`,
    [SubscriptionCancelReason.NotUsingEnough]: `I'm not using it enough`,
    [SubscriptionCancelReason.CustomersPayOnTime]: `My customers now pay on time`,
    [SubscriptionCancelReason.ClosingBusiness]: `I'm closing or selling the business`,
    [SubscriptionCancelReason.PoorSupport]: `The support wasn't good enough`,
    [SubscriptionCancelReason.DidNotWork]: `It didn't work for me`,
    [SubscriptionCancelReason.Other]: `Other`,
};
//# sourceMappingURL=cancellationReasons.js.map